import {AppButton} from '@/components/Button';
import appContent from '@/services/content/appContent.typed';

import {useRescheduleFlow} from './ReschedulePopup/RescheduleFlowContext';

interface StatusActiveRescheduleButtonProps {
    className?: string;
}

const StatusActiveRescheduleButton = ({className}: StatusActiveRescheduleButtonProps) => {
    const {open} = useRescheduleFlow();
    const {rescheduleButton} = appContent.getAutoDeliveryContent()?.extendedDetailsContent || {};

    if (!rescheduleButton) {
        return null;
    }

    return (
        <AppButton primary light className={className} onClick={open} aria-label={rescheduleButton.alt}>
            {rescheduleButton.text}
        </AppButton>
    );
};

export default StatusActiveRescheduleButton;
